<template>
  <!-- @open="handleOpen" @close="handleClose" :collapse="isCollapse" -->
  <!-- <div class="menu-box"> -->
  <el-menu
    class="el-menu-vertical"
    :default-active="menuActive"
    :collapse="isShowMenu"
    unique-opened
    router
  >
    <template v-for="(item, i) in MENU_LIST">
      <template v-if="!item.childMenus">
        <el-menu-item :index="item.url" :key="`${i}`">
          <i :class="item.iconName"></i>
          <span slot="title">{{ item.menuName }}</span>
        </el-menu-item>
      </template>

      <template v-else>
        <el-submenu :index="String(i)" :key="i">
          <template slot="title">
            <i :class="item.iconName"></i>
            <span slot="title">{{ item.menuName }}</span>
          </template>
          <template v-for="(item2, i2) in item.childMenus">
            <template v-if="!item2.childMenus">
              <el-menu-item :key="`${i}-${i2}`" :index="item2.url">{{
                item2.menuName
              }}</el-menu-item>
            </template>

            <template v-else>
              <el-submenu
                :index="`${String(i)}-${String(i2)}`"
                :key="`${i}-${i2}`"
              >
                <template slot="title">
                  <!-- <i :class="item.iconName"></i> -->
                  <span slot="title">{{ item2.menuName }}</span>
                </template>
                <template v-for="(item3, i3) in item2.childMenus">
                  <el-menu-item :key="`${i}-${i2}-${i3}`" :index="item3.url">{{
                    item3.menuName
                  }}</el-menu-item>
                </template>
              </el-submenu>
            </template>
          </template>
        </el-submenu>
      </template>
    </template>
  </el-menu>
  <!-- </div> -->
</template>
<script>
import { menu, submenu, menuItem, menuItemGroup, Form } from "element-ui";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "left-menu",
  props: {
    isShowMenu: {
      type: Boolean,
    },
  },
  data() {
    return {
      menuActive: "/dashboard/index",
    };
  },
  methods:{
    ...mapActions([
      'GET_MENU_LIST'
    ]),
    getMenuList(){
      let {KEY} = this;
      this.GET_MENU_LIST({
        // key: KEY
      }).then(dt=>{
        
        // console.log(dt)
      })
    }
  },
  
  mounted() {
    
  },
  computed: {
    ...mapGetters(["MENU_LIST"]),
    ...mapGetters('user',['KEY'])
  },
  components: {
    elMenu: menu,
    elSubmenu: submenu,
    elMenuItem: menuItem,
    elMenuItemGroup: menuItemGroup,
  },
  watch: {
    $route(c, b) {
      // console.log(b)
      if (c.path === "/") {
        this.menuActive = "/dashboard/index";
      } else {
        this.menuActive = this.$route.path;
      }
    },
  },
};
</script>
<style scoped>
.el-menu-vertical:not(.el-menu--collapse) {
  height: calc(100vh - 61px);
  width: 179px;
  border-right: 1px solid #e6e6e6;
}
</style>
<style>
.el-submenu .el-menu-item {
  min-width: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/leftMenu.vue